/**
 * MM PDP: 選んでいる購入プラン(定期/1回)を商品情報セクションの data-mm-plan に反映する。
 *
 * - data-mm-plan="subscription|onetime" を `.shopify-section`(購入欄と固定の購入バーの両方を含む)に付ける。
 * - 判定は、アプリのラジオ input[name="plan"]:checked を第一に、無ければ購入フォームの
 *   input[name="selling_plan"] の有無で行う。
 * - 強調・枠の出し分け・ボタンの文言は CSS が data-mm-plan を見て切り替える。
 *   このファイルが動かなくても、価格と条件は Liquid が両方出している(誤った価格は出ない)。
 * - アプリが描かれる前は何もしない(属性を付けない)。アプリのラジオか selling_plan の入力が見えてから付ける。
 */
(() => {
  const ROOT_SELECTOR = '[data-mm-plan-root]';
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  /** @type {Element | null} */
  let scope = null;
  let sawSellingPlan = false;

  /** @param {string | null | undefined} value */
  const normalize = (value) => {
    if (value === 'subscription' || value === 'onetime') return value;
    return null;
  };

  const findScope = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    return root ? root.closest('.shopify-section') : null;
  };

  const readPlan = () => {
    if (!scope) return null;

    const radio = scope.querySelector('input[name="plan"]:checked');
    if (radio instanceof HTMLInputElement) {
      const fromRadio = normalize(radio.value);
      if (fromRadio) return fromRadio;
    }

    const form = scope.querySelector(FORM_SELECTOR);
    if (form) {
      const input = form.querySelector('input[name="selling_plan"]');
      if (input instanceof HTMLInputElement && input.value) {
        sawSellingPlan = true;
        return 'subscription';
      }
      // 定期を一度でも見たあとで入力が消えたら、1回決済に切り替わったとみなす
      if (sawSellingPlan) return 'onetime';
    }

    return null;
  };

  const update = () => {
    if (!scope) scope = findScope();
    if (!scope) return;

    const plan = readPlan();
    if (plan && scope.getAttribute('data-mm-plan') !== plan) {
      scope.setAttribute('data-mm-plan', plan);
    }
  };

  const init = () => {
    scope = findScope();
    if (!scope) return;

    // アプリが描かれる前は属性を付けない（価格の2行と2つの条件の枠を両方出したまま）。
    // 先に「定期便」にすると、アプリが読み込めないときに、表示は定期便・実際のカートは1回決済、とずれるため。

    document.addEventListener('change', update);

    const observer = new MutationObserver(update);
    observer.observe(scope, { childList: true, subtree: true });

    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
